import react, { useState, useEffect , useRef } from 'react';
import Select from 'react-select';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';

import classes from './ApplyLeave.module.scss'
import { openCloseApplyLeave } from '../../Redux/action/interactions';
import { leaveBalance, restrictedHoliday, sanctionOfficer, applyLeaves } from '../../API/API';

const Modal = ({ lvBalance }) => {

    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data'));

    const dispatch = useDispatch();

    const EXCEEDED_REQUESTED_LEAVE = useRef('');
    const NO_SANCTION_OFFICER = useRef('');
    const [casualLeave, setCasualLeave] = useState(false)
    const [rHoliday, setRHoliday] = useState([]);
    const [leaveDays, setLeaveDays] = useState(0);
    const [balance, setBalance] = useState(lvBalance);
    const [actualDays, setActualDays] = useState(0);
    const [leaveParams, setLeaveParams] = useState({
        leaveType: {
            value: "",
            label: ""
        },
        rHoliday: {
            text: "",
            value: ""
        },
        leaveFrom: {
            date: "",
            afternoon: false,
            forenoon: true,
        },
        leaveTill: {
            date: "",
            afternoon: true,
            forenoon: false,
        },
        location: "",
        remarks: "",
        leaveDays: 0
    })


    const leaveTypes = [
        { value: "CL", label: "Casual Leave" },
        { value: "RH", label: "Restricted Holiday" },
        { value: "LHAP", label: "Leave on Half Average Pay" },
        { value: "LAP", label: "Leave on Average Pay" },
        // { value: "HQ", label: "Permission to Leave Headquater" },
        // { value: "CR", label: "Compensatory Rest" }
    ]

    useEffect(() => {
        if(window.env !==null){
            EXCEEDED_REQUESTED_LEAVE.current = window.env.ERROR.EXCEEDED_REQUESTED_LEAVE
            NO_SANCTION_OFFICER.current = window.env.ERROR.NO_SANCTION_OFFICER
        }

        if (userID !== null && data !== null) {

            restrictedHoliday(userID, data.empid, data.token)
                .then(response => {
                    setRHoliday(response.data.map(item => {
                        return {
                            value: item.value,
                            label: item.text
                        }
                    }))
                })
                .catch()
        }


        return () => {

        }

    }, [])

    //for Selecting leavetype
    const handleLeaveType = (selectedOption) => {
        setLeaveParams({ ...leaveParams, leaveType: selectedOption })
    }

    //for selecting Restricted Holiday
    const handleRHoldiay = (event) => {
        setLeaveParams({ ...leaveParams, rHoliday: event })
    }

    //for Selecting Remarks
    const handleRemarks = (event) => {
        setLeaveParams({ ...leaveParams, remarks: event.target.value })
    }

    const handleLocation = (event) => {
        setLeaveParams({ ...leaveParams, location: event.target.value })
    }

    const resetState = () => {
        setLeaveParams({
            leaveType: {
                value: "",
                label: ""
            },
            rHoliday: {
                text: "",
                value: ""
            },
            leaveFrom: {
                date: "",
                afternoon: false,
                forenoon: true,
            },
            leaveTill: {
                date: "",
                afternoon: true,
                forenoon: false,
            },
            location: "",
            remarks: "",
            leaveDays: 0
        })
    }



    //for Selecting From Date
    const fromDate = (event) => {
        if (event.target.name === "leaveFrom") {
            setLeaveParams({ ...leaveParams, leaveFrom: { ...leaveParams.leaveFrom, date: event.target.value } })
        }
        else if (event.target.name === "inAfternoon") {
            setLeaveParams({ ...leaveParams, leaveFrom: { ...leaveParams.leaveFrom, afternoon: !leaveParams.leaveFrom.afternoon, forenoon: false } })

        }
        else if (event.target.name === "inForenoon") {
            setLeaveParams({ ...leaveParams, leaveFrom: { ...leaveParams.leaveFrom, forenoon: !leaveParams.leaveFrom.forenoon, afternoon: false } })
        }

    }

    //for Selecting Till Date
    const tillDate = (event) => {
        if (event.target.name === "leaveTill") {
            setLeaveParams({ ...leaveParams, leaveTill: { ...leaveParams.leaveTill, date: event.target.value } })
        }
        else if (event.target.name === "fromAfternoon") {
            setLeaveParams({ ...leaveParams, leaveTill: { ...leaveParams.leaveTill, afternoon: !leaveParams.leaveTill.afternoon, forenoon: false } })

        }
        else if (event.target.name === "fromForenoon") {
            setLeaveParams({ ...leaveParams, leaveTill: { ...leaveParams.leaveTill, forenoon: !leaveParams.leaveTill.forenoon, afternoon: false } })
        }
    }


    //Leave Type Logic and calculate Number of Days
    useEffect(() => {
        const fDate = leaveParams.leaveFrom.date;
        const tDate = leaveParams.leaveTill.date;


        const fromDate = new Date(fDate);
        const tillDate = new Date(tDate);



        if (isNaN(fDate) && isNaN(tDate)) {
            const timeDiff = Math.abs(tillDate.getTime() - fromDate.getTime());
            const days = Math.ceil(timeDiff / (1000 * 3600 * 24));

            if (fromDate.getTime() > tillDate.getTime()) {
                setActualDays(0)
                setLeaveDays(0)
                setLeaveParams({ ...leaveParams, leaveFrom: { ...leaveParams.leaveFrom, date: "" }, leaveTill: { ...leaveParams.leaveTill, date: "" } })
                toast.error('From Date is greater than Till Date')
                return;
            }

            setActualDays(days)
        }

        if (leaveParams.leaveType.value === "CL") {
            setCasualLeave(true)
            setLeaveDays(0)
            if (isNaN(fDate) && isNaN(tDate)) {
                if ((leaveParams.leaveFrom.forenoon === true && leaveParams.leaveTill.forenoon === true)) {
                    setLeaveDays(actualDays + 0.5)
                } else if (leaveParams.leaveFrom.forenoon === true && leaveParams.leaveTill.afternoon === true) {
                    setLeaveDays(actualDays + 1)
                } else if (leaveParams.leaveFrom.afternoon === true && leaveParams.leaveTill.forenoon === true) {
                    if (actualDays === 0) {
                        toast.error('Please Enter Valid Date Range')
                        setLeaveParams({ ...leaveParams, leaveFrom: { ...leaveParams.leaveFrom, date: "" }, leaveTill: { ...leaveParams.leaveTill, date: "" } })
                    }
                    setLeaveDays(actualDays)
                } else if (leaveParams.leaveFrom.afternoon === true && leaveParams.leaveTill.afternoon === true) {
                    setLeaveDays(actualDays + 0.5)
                }
            }

        } else if (leaveParams.leaveType.value === "RH") {
            setLeaveDays(1)

            setCasualLeave(false)
        } else if (leaveParams.leaveType.value === "LHAP") {
            setCasualLeave(false)

            if (isNaN(fDate) && isNaN(tDate)) {
                const doubleDays = (actualDays + 1)
                setLeaveDays(doubleDays)
            }
        } else if (leaveParams.leaveType.value === "LAP") {
            if (isNaN(fDate) && isNaN(tDate)) {
                setLeaveDays(actualDays + 1)
                setCasualLeave(false)
            }

        } else {
            setCasualLeave(false)
        }
    }, [actualDays, leaveParams.leaveType.value, leaveParams.leaveFrom.afternoon, leaveParams.leaveFrom.date, leaveParams.leaveFrom.forenoon, leaveParams.leaveTill.afternoon, leaveParams.leaveTill.date, leaveParams.leaveTill.forenoon, leaveParams])

    //leave API will be handled here
    const handleAPI = (lvType, dateFrom, sessionFrom, dateTo, sessionTo, lvDays, location, remarks) => {
        if (lvType !== null && data !== null && userID !== null) {
            sanctionOfficer(userID, data.empid, data.token, lvType, lvDays)
                .then(response => {
                    if (response.data.sanction !== null && response.data.sanction_nd !== null) {

                        const sFrom = lvType === "CL" ? sessionFrom : "FN";
                        const sTo = lvType === "CL" ? sessionTo : "AN";

                        applyLeaves(userID, data.empid, data.token, lvType, dateFrom, sFrom, dateTo, sTo, lvDays, response.data.boss, response.data.sanction, location, remarks)
                            .then(res => {
                                if (res.data.value === "OK") {
                                    toast.success(`Your ${lvType} Approval has been sent to ${response.data.sanction_nd.split(',')[0]}`,{
                                        duration:4500
                                    })
                                    dispatch(openCloseApplyLeave(false))
                                    resetState();
                                }else if(res.data.value === 'ERROR:QUOTA EXCEEDED(PENDING+THIS LEAVE)') {
                                    toast.error(EXCEEDED_REQUESTED_LEAVE.current);
                                    resetState();
                                    dispatch(openCloseApplyLeave(false))
                                }
                                else {
                                    toast.error(`You've exceeded your ${lvType} Quota`);
                                    resetState();
                                    dispatch(openCloseApplyLeave(false))
                                }
                            })
                    } else {
                        toast.error(NO_SANCTION_OFFICER.current)
                    }
                })
        }   

    }

    const handleSubmit = (event) => {
        event.preventDefault();

        const sessionFrom = leaveParams.leaveFrom.afternoon ? 'AN' : 'FN';
        const sessionTo = leaveParams.leaveFrom.forenoon ? 'AN' : 'FN';


        if (leaveDays > 30) {
            toast.error('Total Leaves Cannot be more than 30' ,{
                duration:4500
              })
            return;
        }

        if (leaveParams.leaveType.value === 'CL') {
            if (data !== null && data.empid !== null) {
                if (isNaN(data.empid) === false) {
                    if (leaveDays > balance.CL) {
                        toast.error('Your Casual Leave Quota is ' + balance.CL ,{
                            duration:4500
                          })
                        return;
                    }
                    handleAPI(leaveParams.leaveType.value, leaveParams.leaveFrom.date, sessionFrom, leaveParams.leaveTill.date, sessionTo, leaveDays, leaveParams.location, leaveParams.remarks)
                } else {
                    handleAPI(leaveParams.leaveType.value, leaveParams.leaveFrom.date, sessionFrom, leaveParams.leaveTill.date, sessionTo, leaveDays, leaveParams.location, leaveParams.remarks)
                }
            }

        } else if (leaveParams.leaveType.value === 'RH') {
            if (leaveDays > balance.RH) {
                toast.error('Your Restricted Holiday Leave Quota is ' + balance.RH ,{
                    duration:4500
                  })
                return;
            }
            handleAPI(leaveParams.leaveType.value, leaveParams.rHoliday.value, "FN", leaveParams.rHoliday.value, "AN", 1, leaveParams.location, leaveParams.remarks)
        } else if (leaveParams.leaveType.value === 'LHAP') {
            if (leaveDays > balance.LHAP) {
                toast.error('Your LHAP Quota is ' + balance.LHAP ,{
                    duration:4500
                  })
                return;
            }
            handleAPI(leaveParams.leaveType.value, leaveParams.leaveFrom.date, "FN", leaveParams.leaveTill.date, "AN", leaveDays, leaveParams.location, leaveParams.remarks)
        } else if (leaveParams.leaveType.value === 'LAP') {
            if (leaveDays > balance.LAP) {
                toast.error('Your LAP Quota is ' + balance.LAP ,{
                    duration:4500
                  })
                return;
            }
            handleAPI(leaveParams.leaveType.value, leaveParams.leaveFrom.date, "FN", leaveParams.leaveTill.date, "AN", leaveDays, leaveParams.location, leaveParams.remarks)
        }
    }


    return (
        <>
            <form className={classes.Modal} onSubmit={handleSubmit}>
                <div className={classes.ClosingButton} ><h2>Apply Leaves</h2><span onClick={() => { dispatch(openCloseApplyLeave(false)) }}>X</span></div>

                <div>
                    <label htmlFor="leaveType">
                        Please Select Leave Type
                    </label>
                    <Select
                        options={leaveTypes}
                        placeholder="Enter Leave Type"
                        onChange={handleLeaveType}
                        isSearchable={true}
                        name='leaveType'
                        value={leaveParams.leaveType}
                        classNamePrefix='filter'
                    />
                </div>
                {leaveParams.leaveType.value === "RH" &&
                    <div>
                        <Select
                            options={rHoliday}
                            placeholder="Enter Restricted Holiday"
                            isSearchable={true}
                            classNamePrefix='filter'
                            onChange={handleRHoldiay}
                            value={leaveParams.rHoliday}
                        />
                    </div>
                }

                {(
                    leaveParams.leaveType.value === "CL" ||
                    leaveParams.leaveType.value === "LHAP" ||
                    leaveParams.leaveType.value === "LHAP" ||
                    leaveParams.leaveType.value === "LAP" ||
                    leaveParams.leaveType.value === "HQ" ||
                    leaveParams.leaveType.value === "CR") &&
                    (<>
                        {/* Leave From */}
                        <div>
                            <div>
                                <label htmlFor="leaveFrom">Enter Leave Date From</label>
                                <input type="date" name='leaveFrom' onChange={fromDate} value={leaveParams.leaveFrom.date} required />
                            </div>
                            {casualLeave && <div className={classes.CheckBox}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                                    <span>Forenoon</span>
                                    <input type="checkbox" name='inForenoon' checked={leaveParams.leaveFrom.forenoon} onChange={fromDate} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                                    <span>Afternoon</span>
                                    <input type="checkbox" name='inAfternoon' checked={leaveParams.leaveFrom.afternoon} onChange={fromDate} />
                                </div>
                            </div>}

                        </div>


                        {/* Leave Till */}
                        <div>
                            <div>
                                <label htmlFor="leaveTill">Enter Leave Date Till</label>
                                <input type="date" name='leaveTill' onChange={tillDate} value={leaveParams.leaveTill.date} required />
                            </div>
                            {casualLeave && <div className={classes.CheckBox}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                                    <span>Forenoon</span>
                                    <input type="checkbox" name='fromForenoon' checked={leaveParams.leaveTill.forenoon} onChange={tillDate} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                                    <span>Afternoon</span>
                                    <input type="checkbox" name='fromAfternoon' checked={leaveParams.leaveTill.afternoon} onChange={tillDate} />
                                </div>
                            </div>}

                        </div>

                    </>)}




                {(leaveParams.leaveType.value === "CL" || leaveParams.leaveType.value === "RH" || leaveParams.leaveType.value === "LHAP" || leaveParams.leaveType.value === "LAP" || leaveParams.leaveType.value === "HQ") && <>
                    <div>
                        <label htmlFor="location">Enter Location</label>
                        <input type="text" placeholder='Enter Location' name='location' value={leaveParams.location} autoComplete="off" onChange={handleLocation} required />
                    </div>

                    <div>
                        <label htmlFor="remarks" >Enter Remarks</label>
                        <input type="text" placeholder='Enter Remarks' name='remarks' value={leaveParams.remarks} autoComplete="off" onChange={handleRemarks} required />
                    </div>

                    {
                        leaveParams.leaveType.value === "RH" &&
                        <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                            <h2>Date:</h2><p>{leaveParams.rHoliday.value !== null && leaveParams.rHoliday.value.split('-').reverse().join('/')}</p>
                        </div>
                    }

                    {
                        leaveParams.leaveType.value === "LHAP" &&
                        <div style={{ display: 'flex', alignItems: 'center', gap: "10px", marginBottom: "-10px" }}>
                            <h3>Total LHAP leaves deducted:</h3><p>{leaveDays * 2}</p>
                        </div>
                    }

                    <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                        <h3>Total Leave Days:</h3><p>{leaveDays}</p>
                    </div>


                    <div style={{ height: "100%", display: 'flex' }}>
                        <button type='submit'>Send Leave Request</button>
                    </div>
                </>
                }

            </form>
        </>)
}

export default Modal